import { authenticatedHttpClient } from './httpClient';
import { ExchangeSource } from '../models/exchangeSource';

function parseOptionalDate(value: unknown): Date | undefined {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  if (typeof value === 'object' && value !== null && 'seconds' in value) {
    return new Date((value as { seconds: number }).seconds * 1000);
  }
  const parsed = new Date(String(value));
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

function mapExchangeSource(
  data: Record<string, unknown>,
  id: string,
  input: { fromCurrency: string; toCurrency: string }
): ExchangeSource {
  return {
    id,
    name: data.name as string | undefined,
    rate: (data.rate as number | undefined) ?? 0,
    sourceUrl: (data.sourceUrl as string | undefined) ?? '',
    fromCurrency: (data.fromCurrency as string | undefined) ?? input.fromCurrency,
    toCurrency: (data.toCurrency as string | undefined) ?? input.toCurrency,
    dataStructure: (data.dataStructure as string | undefined) ?? '',
    rateFieldPath: (data.rateFieldPath as ExchangeSource['rateFieldPath']) ?? 'rate',
    lastFetchedAt: parseOptionalDate(data.lastFetchedAt),
    created: parseOptionalDate(data.created),
    updated: parseOptionalDate(data.updated),
    schedulerEnabled: data.schedulerEnabled as boolean | undefined,
    schedulerFrequencyMinutes: data.schedulerFrequencyMinutes as number | undefined,
    schedulerTimeZone: data.schedulerTimeZone as string | undefined,
    schedulerJobName: data.schedulerJobName as string | undefined,
    schedulerJobId: data.schedulerJobId as string | undefined,
    schedulerLocation: data.schedulerLocation as string | undefined,
    schedulerSchedule: data.schedulerSchedule as string | undefined,
    schedulerTargetBaseUrl: data.schedulerTargetBaseUrl as string | undefined,
    keywords: data.keywords as string[] | undefined,
  };
}

export const listExchangeSourcesForPair = async (input: {
  fromCurrency: string;
  toCurrency: string;
}): Promise<ExchangeSource[]> => {
  const params = new URLSearchParams({
    fromCurrency: input.fromCurrency,
    toCurrency: input.toCurrency,
  });
  const rows = await authenticatedHttpClient.get<Record<string, unknown>[]>(
    `/exchange-sources?${params.toString()}`
  );
  return rows.map(row => {
    const id = String(row.id ?? '');
    return mapExchangeSource(row, id, input);
  });
};
